"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldsComponent = void 0;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const errorColor = "red";
const TextInputField = (0, styled_components_1.default)(Elements.InputText) `
  color: ${(props) => (props.valid ? "currentcolor" : errorColor)};
`;
const FieldsContainer = (0, styled_components_1.default)(Elements.FlexContainerRowWithPadding) `
  > ${Elements.InnerContainer} {
    width: 200px;

    > ${Elements.InputLabel} {
      > ${TextInputField} {
        display: block;
        width: 100%;
      }
    }

    p.details {
      color: #666;
    }
  }
`;
const FormFieldsComponent = (props) => (React.createElement(FieldsContainer, null, props.fields.map((field, i) => (React.createElement(Elements.InnerContainer, { key: i },
    React.createElement(Elements.InputLabel, null,
        field.label,
        React.createElement(TextInputField, { type: "text", placeholder: field.placeholder, value: field.value, valid: field.valid, onChange: (e) => field.onChange(e.currentTarget.value) })),
    field.details && React.createElement("p", { className: "details" }, field.details))))));
exports.FormFieldsComponent = FormFieldsComponent;
//# sourceMappingURL=form-fields-component.js.map